export default __webpack_public_path__ + "static/media/pop8.df02942f.jpg";